exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-separator {\n  width: 100%;\n  text-align: left;\n  border-bottom: 1px solid lightgrey;\n  line-height: 0.1em;\n  margin: 2em 0;\n  color: darkgrey;\n  font-size: 1.3em; }\n\n.section-separator span {\n  background: #fff;\n  padding: 0 10px; }\n\n.form-control:disabled,\n.form-control[readonly] {\n  background-color: #f1eeee; }\n\n.help-block {\n  color: red;\n  font-size: 0.95em; }\n\n.sticky-header {\n  z-index: 999;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  margin-bottom: 10px; }\n\ntable {\n  margin: 2em 1.2em;\n  table-layout: fixed;\n  width: 100%; }\n\nth,\ntd {\n  padding: 10px; }\n\ntd button {\n  color: #fff;\n  margin: 0 0.2em;\n  text-align: center;\n  border: 1px solid transparent; }\n\ntd button.download {\n  background-color: #20a8d8;\n  border-color: #20a8d8; }\n\ntd button.delete {\n  background-color: #f86c6b;\n  border-color: #f86c6b; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/trading-partners/tp-new-vendor/tp-new-vendor.component.scss
// module id = ../../../../../angular/app/views/trading-partners/tp-new-vendor/tp-new-vendor.component.scss
// module chunks = main